import { primary } from "../../../theme/themeColors";

export interface IStylesType {
  [key: string]: React.CSSProperties | IStylesType;
}

export const styles: IStylesType = {
  header: {
    width: "100%",
  },
  logoContainer: {
    width: "100%",
    borderBottom: "1px solid #eff0ef54",
    paddingBottom: "0.5rem",
  },
  institutionLogoContainer: {
    display: "flex",
    width: "100%",
    gap: "0.5rem",
    alignItems: "center",
    padding: "0.8rem 0rem",
  },
  menuListContainer: {
    overflowY: "auto",
    flex: 1,
    width: "100%",
  },
  menuItemButton: {
    gap: "0.5rem",
    borderRadius: "10px",
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: "#aeaeae29",
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
  },
  menuItemIcon: {
    minWidth: "0px",
    "&.MuiListItemIcon-root .MuiSvgIcon-root": {
      color: "#dfdfdf",
    },
  },
  menuItemText: {
    "& > span": {
      fontWeight: "500",
      color: "#dfdfdf",
    },
  },
  collapseContainer: {
    marginLeft: "28px",
    borderLeft: "1px solid #7fa684",
  },
  submenuItemButton: {
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: "#aeaeae29",
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
    },
  },
  subMenuGroupButton: {
    position: "relative",
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: "#aeaeae29",
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
    },
    "&.MuiListItemButton-root::before": {
      position: "absolute",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      top: 0,
      bottom: 0,
      left: "-3.5px",
      backgroundColor: "#fff",
      content: '""',
      marginTop: "auto",
      marginBottom: "auto",
      zIndex: 1,
    },
  },
  groupCollapseContainer: {
    marginLeft: "-2.5px",
    borderLeft: "4px solid #7fa684",
  },
  groupItemButton: {
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: "#aeaeae29",
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
    },
  },
  menuItemGeneralSettingText: {
    "& > span": {
      fontWeight: "500",
      color: "#1c2437",
      marginTop: "0px",
      marginBottom: "0px",
    },
  },
  menuItemGeneralSettingButton: {
    padding: "2px",
  },
};

export const compactMenuStyles: IStylesType = {
  drawer: {
    "& .MuiPaper-root": {
      width: "20%",
    },
  },
  logoContainer: {
    width: "100%",
    borderBottom: "1px solid #eff0ef54",
    paddingBottom: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 1.5,
  },
  menuItemText: {
    "& > span": {
      fontWeight: "500",
      color: "#000",
      fontSize: 13,
    },
  },
  institutionLogoContainer: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
    padding: "0.8rem",
    width: "100%",
    paddingBottom: "0.5rem",
    justifyContent: "center",
  },
  menuItemButton: {
    paddingTop: "4px",
    paddingBottom: "4px",
    marginLeft: -2,
    "&:hover": {
      backgroundColor: primary.main,
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: primary.main,
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
    },
  },
  backToMenuButton: {
    display: "flex",
    marginBottom: 2,
    marginLeft: -1,
    height: 35,
    lineHeight: 0,
    width: "100%",
    backgroundColor: primary.main,
    "&:hover": {
      backgroundColor: primary.main,
    },
  },
};

export const RightSideBarStyles = {
  icon: {
    size: 30,
    backgroundColor: "#ffffff",
  },
  iconWrapper: {
    borderRadius: "50%",
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff",
  },
  taskContainer: {
    width: "100%",
    height: 100,
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid #D9D9D9",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  label: {
    marginTop: 1,
    fontSize: 11,
    fontWeight: 500,
    textAlign: "center",
  },
};
